export const decodeHtmlSpecialChars = (text) => {
  const map = {
    '&amp;': '&',
    '&#038;': "&",
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#039;': "'",
    '&#8217;': "’",
    '&#8216;': "‘",
    '&#8211;': "–",
    '&#8212;': "—",
    '&#8230;': "…",
    '&#8221;': '”'
  }

  // eslint-disable-next-line
  return text.replace(/\&[\w\d\#]{2,5}\;/g, (m) => {return map[m]})
}


// WEBPACK FOOTER //
// ./src/services/service-decode-html-special-chars.js